// 将request.js整体导入
import request from './request'
 
// 按需导出每个请求，也就是按需导出每个api
 
// 请求首页数据
export const GetHomeAPI = (params) => request.get('/api/series_data', {params});
//pc导航
export const GetNavAPI = (params) => request.get('/api/nav_list/1', {params});
//手机端导航 api/liuyan/h5_home_nav/1
export const GetphoneNavAPI = (params) => request.get('/api/liuyan/h5_home_nav/1', {params});
//视频接口
export const video_url = (params) => request.get('/api/1/get_article', {params});
//新闻接口
export const news_url = (params) => request.get('/api/1/get_article', {params});
//文章管理类型
export const get_article_cate_url = (params) => request.get('/api/get_article_cate', {params});
 //轮播图接口
 export const carousel_url = (params) => request.get('/api/1/posters_info', {params});
 //用户注册
 export const registerAPI = (params) => request.post('/api/register', params);
// 密码登录
export const PostLoginAPI = (params) => request.post('/api/login', params);
//忘记密码
export const forgetAPI = (params) => request.post('/api/forget', params);
//发送验证码
export const send_code_API = (params) => request.post('/api/sendshort', params);
//验证码登录
export const code_login_url = (params) => request.post('/api/testlogin', params);
//修改密码
export const forgetnext_API = (params) => request.post('/api/forgetnext', params);
// 退出
export const PostOutAPI = (params) => request.post('/api/logout', params);
//产品列表
export const product_detailsAPI = (params) => request.get('/api/productInfo', {params});
//单个产品详情
export const product_detail_urlAPI = (params) => request.post('/api/productDetail', params);
//推荐商品
export const product_recommend_url = (params) => request.post('/api/recommend', params);
//退出登录
export const logout_url = (params) => request.post('/api/logout', params);
//产品列表页
export const product_list_data_url = (params) => request.get('/api/product_list_data', {params});
//常见问题
export const quest_url = (params) => request.get('/api/questionInfo', {params});
export const salesInfo_url = (params) => request.get('/api/salesInfo', {params});
//联系我们
export const callme_url = (params) => request.get('/api/get_website/1', {params});
export const callmeimg_url = (params) => request.get('/api/1/posters_info', {params});
//新闻详情
export const newsDetail_url = (params) => request.get('/api/get_article_detail', {params});
//品牌权威
export const authority_url = (params) => request.get('/api/1/get_brand', {params});
//授权查询
export const Authorization_api = (params) => request.post('/api/agent/info', params);

//创建收货地址
export const create_address_url = (params) => request.post('/api/address/create', params);
//获取收获地址 
export const get_ship_address_url = (params) => request.post('/api/address/show', params);
//获取单个产品
export const product_detail_url = (params) => request.post('/api/productDetail', params);
//显示已选产品
export const select_shopping_car_url = (params) => request.post('/api/shopping/select', params);
// 购物车删除商品
export const Destroy_shopping_car_url = (params) => request.post('/api/shopping/destroy', params);
//购物车删除商品
export const destroy_shopping_car_url = (params) => request.post('/api/shopping/destroy', params);
//购物车修改商品
export const edit_shopping_car_url = (params) => request.post('/api/shopping/edit', params);
//加入购物车
export const create_shopping_car_url = (params) => request.post('/api/shopping/create', params);
// 获取购物车
export const create_shoppingshow_url = (params) => request.post('/api/shopping/show', params);
//生成订单
export const addOrder_url = (params) => request.post('/api/orders/addOrder', params);
//获取用户信息
export const get_user_info_url = (params) => request.post('/api/user/show', params);
//修改或新增个人信息
export const save_user_info_url = (params) => request.post('/api/user/store', params);
//获取收获地址
export const get_address_url = (params) => request.post('/api/address/show', params);
//删除收获地址
export const del_address_url = (params) => request.post('/api/address/destroy', params);
//获取订单
export const orders_url = (params) => request.post('/api/orders/getOrders', params);
//获取已完成订单
export const complete_orders_url = (params) => request.post('/api/orders/getCompleteOrders', params);
//取消订单
export const quit_order_url = (params) => request.post('/api/orders/quitOrder', params);
//获取未完成
export const get_unfinished_orders_url = (params) => request.post('/api/orders/getUnfinishOrders', params);
//设置默认地址
export const default_Address_url = (params) => request.post('/api/address/store', params);
//修改地址 
export const edit_address_url = (params) => request.post('/api/address/edit', params);
//获取订单详情
export const orders_i_url = (params) => request.post('/api/orders/ordersDetail', params);
//从我的订单去支付
export const payOrder_url = (params) => request.post('/api/orders/payOrder', params);
//支付页面
export const orderDetail_url = (params) => request.post('/api/orders/orderDetail', params);
//微信登录
export const wechatlogin_url = (params) => request.post('/api/wechat/wechatlogin', params);
//支付宝登录 
export const ali_login_url = (params) => request.post('/api/alipay/alilogin', params);
//绑定手机号
export const binding_url = (params) => request.post('/api/wechat/wechatloginbound', params);
//手机端首页新品列表
export const homelist_url = (params) => request.get('/api/h5_home_list', {params});
// 手机端底部产品分类模块
export const h5_home_classify = (params) => request.get('/api/liuyan/h5_home_classify', {params});
//收藏
export const collect_url = (params) => request.get('/api/user/save_collection', {params});
// 取消收藏
export const collection_del_url = (params) => request.get('/api/user/collection_del', {params});

// 收藏列表
export const collection_list_url = (params) => request.get('/api/user/collection_list', {params});

// 搜索接口api/search?param=燕窝
export const search_url = (params) => request.get('/api/search', {params});

//退款
export const order_refund = (params) => request.post('/api/orders/order_refund', params);



// WEBPACK FOOTER //
// ./src/request/api.js